import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Papa from 'papaparse';
import {
  USER_OPERATIONS,
  RESOURCE_TYPE,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  DATE_FORMAT,
} from "../../constants";
import defaultStyles from "./EvrNumberUpdate.module.css";
import "../../cssModules/switch.css";
import { BackButton } from "..";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import { withAllowedOperationsProvider } from "../../hocs";
import Table from "../Table/Table";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { useHistory } from "react-router-dom";
import { API } from "../../apis/api";
import EvrNumberForm from "../EvrNumberForm/EvrNumberForm";
import { downloadCsv, exportToExcelEvrNumber, getMonthNameWithYear } from "../../utils/utils";
import { buildErrorMessage, getEvrNumberPerPlant } from "../../apis/calls";
import moment from "moment";
import EvrNumberToolbar from "../EvrNumberToolbar/EvrNumberToolbar";
import AddEvrNumberForm from "../AddEvrNumberForm/AddEvrNumberForm";
import { useErrorHandler } from "react-error-boundary";
import EvrCarryForwardModal from "../EvrCarryForwardModal/EvrCarryForwardModal";

const EvrNumberUpdate = ({
  setHasActiveEdits,
  hasActiveEdits,
  handleCountChange,
}) => {
  const ROW_HEIGHT = 38;
  const RESOURCE_OPERATION_UPDATE = USER_OPERATIONS.UPDATE_EVR_QUANTITY;
  const RESOURCE_OPERATION_ADD_CSV = USER_OPERATIONS.ADD_EVR_DATA;
  const { showError, showInternalError, showPopup ,showLoading , closePopUp} = usePopupManager();
  const [plant] = usePlantAndLinesStore().plantState;
  
  const history = useHistory();

  const [styles, setStyles] = useState(defaultStyles);

  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  
  const [selectedRow, setSelectedRow] = useState(null); 

  const [asnCount, setAsnCount] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [activeMonthNameWithYear, setActiveMonthNameWithYear] = useState(
    getMonthNameWithYear(moment())
  );
  const [colours, setColours] = useState({ loading: false, data: [] });
  const [countries, setCountries] = useState({ loading: false, data: [] });
  const [isAddEvrNumberFOrm, setIsAddEvrNumberForm] = useState(false);
  const [carryForwardEvrDetails, setCarryForwardEvrDetails] = useState({});
  const [isCarryForwardModalOpen, setIsCarryForwardModalOpen] = useState(false);
  const [carryForwardEvrCount, setCarryForwardEvrCount] = useState({});

  const setCount = (count) => {
    setAsnCount(count);
  };
  const handleError = useErrorHandler();

  const openCarryForwardModal = () => setIsCarryForwardModalOpen(true);
  const closeCarryForwardModal = () => setIsCarryForwardModalOpen(false);
    const closeAddEvrNumberFOrm = () => setIsAddEvrNumberForm(false);
  

  const handleCarryForwardEvrNumber = (selectedRows) => {
      const allPlannedEvrNumbers = selectedRows.filter(
        rowData => rowData.quantity !== rowData.updatedEvrQuantity,
      );
      setCarryForwardEvrDetails(allPlannedEvrNumbers);
      setCarryForwardEvrCount(allPlannedEvrNumbers.length);
      openCarryForwardModal();
    };

  const loadPlanDataOfActiveMonth = () => {
      const selectedMonthNameWithYear = activeMonthNameWithYear.split('-'); // activeMonthNameWithYear will be in form Jan-2021
  
      const selectedMonthName = selectedMonthNameWithYear[0];
      const yearOfSelectedMonth = selectedMonthNameWithYear[1];
  
      const startDate = moment()
        .month(selectedMonthName)
        .year(yearOfSelectedMonth)
        .startOf('month');
      const startDateString = startDate.format(DATE_FORMAT.ISO);
      const endDate = moment()
        .month(selectedMonthName)
        .year(yearOfSelectedMonth)
        .endOf('month');
      const endDateString = endDate.format(DATE_FORMAT.ISO);
      
      
      return getEvrNumberData(startDateString, endDateString);
    };

  const fixedColumns = [
    {
      width: 140,
      title: "Evr Number",
      field: "evrNumber",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "VC Number",
      field: "vc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Valid From",
      field: "validFrom",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Valid To",
      field: "validTo",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Country Code",
      field: "countryCode",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Country Name",
      field: "countryName",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Quantity",
      field: "quantity",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Balance Quantity",
      field: "updatedEvrQuantity",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Colour Code",
      field: "colourCode",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 160,
      title: "Colour Description",
      field: "colourDescription",
      enableSearch: true,
      enableFilter: true,
    },
  ].filter((c) => c);

  const redirectToApplicationLandingPage = () => {
    history.push("/");
  };

  const getEvrNumberData = async (fromDate, toDate) => {
    if (plant.value) {
      setRowsData({ loading: true, ...rowsData });
      
      try {
        showLoading();
        let response = await getEvrNumberPerPlant(plant.value,fromDate,toDate);
        const updatedData = response.data.map((item, index) => ({
          ...item,
          id: index + 1 // Serial number starting from 1
        }));
        
        setRowsData({
          loading: false,
          data: updatedData,
          filteredData: updatedData,
        });
        closePopUp();
      } catch (err) {
        console.log(err);
        showInternalError({ error: err });
      }
    }
  };

  const openFormPopup = selectedRow => {
    setShowForm(true);
    setSelectedRow(selectedRow);
  };

  const closeFormPopup = () => {
    setShowForm(false);
  };

  const addEvrNumber = async(formData) => {
    if(plant.value){
      try{
        const response = await API.put(API_RESOURCE_URLS.evrUpdate(plant.value), formData);
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: ' ',
          info: DISPLAY_MESSAGES.UPDATE_EVR_NUMBER,
        });
        closeFormPopup();
        loadPlanDataOfActiveMonth();
      }catch(error){
        showError({
          contextText: DISPLAY_MESSAGES.UPDATE_EVR_NUMBER_ERR,
          error: error,
        });
        closeFormPopup();
      }
    }
  };

  const handleDownloadTemplateButtonClick = () => {
    const link = document.createElement('a');
    link.setAttribute('download', `Evr-Number-upload-Configuration-template.xlsx`);
    exportToExcelEvrNumber().then(dataUri => {
      link.href = dataUri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const response = await API.get(API_RESOURCE_URLS.COUNTRIES);
      const countries = response.data;
      // Create a mapping from country name to country code
      const countryMapping = countries.reduce((map, countryObj) => {
        map[countryObj.country] = countryObj.code;
        return map;
      }, {});
  
      Papa.parse(file, {
        header: true, // The first row contains headers
        skipEmptyLines: true,
        complete: (result) => {
          const requiredHeaders = [
            "Plant",
            "Vc no",
            "Evr Number",
            "Quantity",
            "Valid From (YYYY-MM-DD)",
            "Valid To (YYYY-MM-DD)",
            "Country Name",
            "Colour code",
          ];
          const csvHeaders = result.meta.fields;
          const isValidHeaders = requiredHeaders.every(header => csvHeaders.includes(header));
  
          if (!isValidHeaders) {
            showError({
              contextText: `CSV file is missing required headers.`,
              info: '',
            });
            return;
          }
          const isPlantMatched = result.data.every(row => row["Plant"] === plant.label);
          if (!isPlantMatched) {
            showError({
              contextText: `Plant name in CSV does not match the selected plant: ${plant.label}`,
              info: '',
            });
            return;
          }
          const parsedData = [];
          for (const [index, row] of result.data.entries()) {
            const countryName = row["Country Name"].trim();
            const countryCode = countryName.split(" - ")[0].trim(); 
            if (!countryCode) {
              showError({
                contextText: `Country name "${countryName}" does not have a valid mapping. Error at row number: ${index + 2}`,
              });
              return;
            }
            const colourName = row["Colour code"].trim();
            const colourCode = colourName.split(" - ")[0].trim(); 
            if (!colourCode) {
              showError({
                contextText: `Colour code "${colourName}" does not have a valid mapping. Error at row number: ${index + 2}`,
              });
              return;
            }
            parsedData.push({
              plant: plant.value,
              vc: row["Vc no"],
              evrNumber: row["Evr Number"],
              quantity: row["Quantity"],
              validFrom: row["Valid From (YYYY-MM-DD)"],
              validTo: row["Valid To (YYYY-MM-DD)"],
              countryCode: countryCode,
              colourCode: colourCode,
            });
          }
          if (parsedData.length > 0) {
            uploadCsvData(parsedData);
          }
        },
        error: (err) => {
          showError({
            contextText: `Error in parsing the CSV file.`,
            info: err,
          });
          console.error(err);
        },
      });
    } catch (error) {
      showError({
        contextText: `Error while fetching the country code data.`,
        info: error,
      });
      console.error(error);
    }
  };
  

  const uploadCsvData = async (data) => {
    if (plant.value) {
      try {
        const response = await API.put(API_RESOURCE_URLS.evrUpload(plant.value), data);
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: DISPLAY_MESSAGES.EVR_NUMBER_UPLOAD_SUCCESS,
          info: `Total rows uploaded: ${data.length}`,
        });
        loadPlanDataOfActiveMonth(); // Refresh data after upload
      } catch (error) {
        showError({
          contextText: DISPLAY_MESSAGES.EVR_NMBER_UPLOAD_FAIL,
          info: '',
          error: error,
        });
      }
    }
  };

  const prepareJsonHeaderAndValueFormats = () => {
  
      const evrHeaderAndValueFormats = [
        {
          label: "Evr Number",
          value: (row) => row.evrNumber,
        },
        {
          label: "VC Number",
          value: (row) => row.vc,
        },
        {
          label: "Valid From",
          value: (row) => row.validFrom,
        },
        {
          label: "Valid To",
          value: (row) => row.validTo,
        },
        {
          label: "Country Code",
          value: (row) => row.countryCode,
        },
        {
          label: "Country Name",
          value: (row) => row.countryName,
        },
        {
          label: "Quantity",
          value: (row) => row.quantity,
        },
        {
          label: "Colour Code",
          value: (row) => row.colourCode,
        },
        {
          label: "Balance Quantity",
          value: (row) => row.updatedEvrQuantity,
        },
      ].filter((c) => c);
  
      return [...evrHeaderAndValueFormats];
    };
  
    const generateAndDownloadEvrNumberCsvReport = (fetchedData) => {
      try {
        if (!rowsData.loading) {
          const dateValue = moment().format(DATE_FORMAT.ISO);
  
          const jsonData = fetchedData;
  
          const allEvrNumbers = [];
  
          const { parseAsync } = require("json2csv");
          const fields = prepareJsonHeaderAndValueFormats(allEvrNumbers);
          const opts = { fields };
          parseAsync(jsonData, opts)
            .then((csv) => {
              const exportedFilename =
                "Evr_Number_Report_" +
                plant.label +
                "_" +
                dateValue +
                ".csv";
              downloadCsv(csv, exportedFilename);
            })
            .catch((error) =>
              console.error(
                "Failed to download EvrNumver report, error:" +
                  buildErrorMessage(error)
              )
            );
        }
      } catch (error) {
        console.error(
          "Failed to download EvrNumber report, error:" +
            buildErrorMessage(error)
        );
      }
    };

  const handleCarryForwardPendingQuantity = async (data) => { 
     if (plant.value) {
      const transformedData = data.rowsData.map(item => ({
        plant: item.plant,
        vc: item.vc,
        evrNumber: item.evrNumber,
        quantity: item.updatedEvrQuantity,
        validTo: data.validToDate,    
        validFrom: data.validFromDate,
        countryCode: item.countryCode,
        colourCode: item.colourCode
      }));
      try {
        const response = await API.put(
          API_RESOURCE_URLS.evrNumberCarryForward(plant.value),
          transformedData
        );
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: DISPLAY_MESSAGES.EVR_NUMBER_CARRY_FORWARD_SUCCESS,
          info: `${data.length}: Evr Numbers Carry forwarded`,
        });
        loadPlanDataOfActiveMonth(); // Refresh data after upload
      } catch (error) {
        showError({
          contextText: DISPLAY_MESSAGES.EVR_NMBER_UPLOAD_FAIL,
          info: error,
          error: error,
        });
      }
    }
  };
  
  const loadData = async (setState, url, params) => {
    try {
      const response = await API.get(url, {
        params: params,
      });
      setState({ loading: false, data: response.data || [] });
    } catch (error) {
      console.error(buildErrorMessage(error));
      handleError(error);
    }
  };

  const loadCountries = async () => {
    return loadData(setCountries, API_RESOURCE_URLS.COUNTRIES);
  };

  const loadColours = async () => {
    return loadData(setColours, API_RESOURCE_URLS.COLOURS);
  };

  const getColourOptions = () => {
    return colours.data.map(({ colourCode, colourDescription }) => ({
      value: colourDescription + " (" + colourCode + ")",
      label: colourDescription + " (" + colourCode + ")",
    }));
  };

  const getCountryCodeOptions = () => {
    return countries.data
      .map(({ code, country }) => ({
        value: code,
        label: `${code} - ${country}`,
      }))
      .sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
  };


  useEffect(() => {
    if (showForm) {
      loadCountries();
      loadColours();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  useEffect(() => {
    handleCountChange(asnCount);
  }, [asnCount, handleCountChange]);

  useEffect(() => {
    setHasActiveEdits(rowsData.data.some((row) => row.edited));
  }, [rowsData.data, setHasActiveEdits]);
  
  useEffect(() => {
      loadPlanDataOfActiveMonth();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [plant.value, activeMonthNameWithYear]);

  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          action="Evr Number configurator"
          handleClick={redirectToApplicationLandingPage}
        />
      </div>
      <EvrNumberToolbar
        plantName={plant.label}
        handleMonthSelect={setActiveMonthNameWithYear}
      />
      <div className={styles.container}>
        <div className={styles.tableView} style={{ height: "100%" }}>
          <Table
            columns={fixedColumns}
            defaultColumns={[...fixedColumns]}
            rowHeight={ROW_HEIGHT}
            rows={rowsData.filteredData}
            setHasActiveEdits={setHasActiveEdits}
            setAsnCount={setCount}
            isDataLoading={rowsData.loading}
            primaryAction={{
              name: "Update",
              actionFn: (selectedRow) => openFormPopup(selectedRow),
              authOperation: RESOURCE_OPERATION_UPDATE,
              shouldEnable: (selectedRows) => selectedRows.length === 1,
            }}
            secondaryActions={[
              {
                name: "DOWNLOAD TEMPLATE",
                actionFn: () => handleDownloadTemplateButtonClick(),
              },
              {
                name: "Upload Evr Number",
                actionFn: () => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = ".csv";
                  input.onchange = handleFileUpload;
                  input.click();
                },
                authOperation: RESOURCE_OPERATION_ADD_CSV,
              },
              {
                name: "ADD Evr Number",
                actionFn: () => setIsAddEvrNumberForm(true),
                authOperation: RESOURCE_OPERATION_ADD_CSV,
              },
              {
                name: "CARRY FORWAD",
                actionFn: (selectedRows) =>
                  handleCarryForwardEvrNumber(selectedRows),
                authOperation: RESOURCE_OPERATION_UPDATE,
                shouldEnable: (selectedRows) =>
                  selectedRows.length &&
                  selectedRows.filter(
                    (row) => row.updatedEvrQuantity !== 0
                  ),
              },
              {
                name: "DOWNLOAD CSV",
                getFilteredData: true,
                authOperation: USER_OPERATIONS.GET_ALL_EVR,
                shouldEnable: () => true,
                actionFn: (filteredData) =>
                  generateAndDownloadEvrNumberCsvReport(filteredData),
              },
            ]}
          />
        </div>
      </div>

      {showForm && (
        <EvrNumberForm
          closeFormPopup={closeFormPopup}
          addEvrNumber={addEvrNumber}
          selectedRow={selectedRow}
          countryOptions={getCountryCodeOptions()}
          colorCodeOptions={getColourOptions()}
        />
      )}
      {isAddEvrNumberFOrm && (
        <AddEvrNumberForm
          title="Evr Number Addition: Add Evr"
          open={isAddEvrNumberFOrm}
          handleClose={closeAddEvrNumberFOrm}
          cancelButtonText="CANCEL"
          submitButtonText="SUBMIT"
          lineBackgroundColor="#608fc9"
          plant={plant}
          countryOptions={getCountryCodeOptions()}
          colorCodeOptions={getColourOptions()}
        />
      )}
      {isCarryForwardModalOpen ? (
        <EvrCarryForwardModal
          open={isCarryForwardModalOpen}
          evrNumberCarryForwardCount={carryForwardEvrCount}
          handleClose={closeCarryForwardModal}
          rowsData={carryForwardEvrDetails}
          handleSubmit={handleCarryForwardPendingQuantity}
        />
      ) : null}
    </>
  );
};

EvrNumberUpdate.propTypes = {
  hasActiveEdits: PropTypes.bool.isRequired,
  setHasActiveEdits: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  EvrNumberUpdate,
  false,
  RESOURCE_TYPE.EVR_QUANTITY
);
